import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { BorerShiftTargetDocument, borerShiftTargetsPullQueryBuilder } from './queryBuilder';

export function borerShiftTargetFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
  equipment: FamilyMember<EquipmentDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BorerShiftTargetDocument> {
  const syncConfig = configBuilder<BorerShiftTargetDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_TARGET,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerShiftTargetsPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_TARGET, replicationState, [
    borerShift,
    equipment,
    sites,
  ]);
}
